const state = {
  currency: JSON.parse(localStorage.getItem('currAcct')) && JSON.parse(localStorage.getItem('currAcct')).currency || 'USD'
}
// getters
const getters = {
  // 获取当前币种
  getCurrency: (state) => {
    return state.currency
  }
}
// mutations
const mutations = {
  // 更新币种
  update_currency (state, currency) {
    state.currency = currency
  }
}
export default {
  state,
  getters,
  mutations
}



// WEBPACK FOOTER //
// ./src/store/modules/currency.js